import { render, staticRenderFns } from "./form-acao-cadastro.vue?vue&type=template&id=00d374ac"
import script from "./form-acao-cadastro.vue?vue&type=script&lang=js"
export * from "./form-acao-cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports